export const AJOUTE_RESTAURANT="AJOUTE_RESTAURANT";
export const SUPRIMER_RESTAURANT="SUPRIMER_RESTAURANT";